import React from 'react'

import routes from 'src/lib/rails-routes/rails-routes'
import { Box, Button } from '@chatterbug/aaron'
import { t } from 'src/lib/i18n-react'

const ScheduleOverbooked = () => {
  return (
    <Box mb="2x">
      <Box variant="text.paragraph" mb="2x">
        {t('To schedule more classes, you need to choose a subscription.')}
      </Box>
      <Button
        type="primaryAdvanced"
        onClick={() => (window.location.href = routes.payments())}
      >
        {t('Choose a Subscription')}
      </Button>
    </Box>
  )
}

export default ScheduleOverbooked
